module.exports = __webpack_public_path__ + "fonts/NunitoSans_7pt-BoldItalic.33bfc3ba.ttf";